/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/*
 * This function is written to handle multiple promises received from rendition provider
 * (ajs and dcapi) client can add callbacks for both promises in do function of this class.
 * functionality like choosing which promise to resolve when can be added here.
 */
import { isFunction } from "utils/lodashUtils";

const docAPIResponseHandler = (
  response,
  ajsResolve = null,
  ajsReject = null,
  dcapiReslove = null,
  dcapiReject = ajsReject
) => {
  if (response.ajs && (response.dcapi || response.external)) {
    let dcapiResponse = "pending";
    let ajsResponse = "pending";
    response.ajs
      .then(ajsResponseData => {
        ajsResponse = "resolved";
        if (isFunction(ajsResolve)) {
          ajsResolve(ajsResponseData);
        }
      })
      .catch(error => {
        /* In case of Non PDF ajs will always reject and dcapi also rejects then	
      we show a dialog	
      In case of PDF ajs will mostly not reject but if it does we can fallback 	
      to non pdf view of PDF. if both reject in case of PDF then we show a dialog */
        ajsResponse = "rejected";
        if (isFunction(ajsReject)) {
          ajsReject(error, ajsResponse, dcapiResponse);
        }
      });
    if (response.external) {
      response.external
        .then(externalResponseData => {
          dcapiResponse = "resolved";
          if (isFunction(dcapiReslove)) {
            dcapiReslove(externalResponseData);
          }
        })
        .catch(error => {
          dcapiResponse = "rejected";
          if (isFunction(dcapiReject)) {
            dcapiReject(error, ajsResponse, dcapiResponse);
          }
        });
    } else {
      response.dcapi
        .then(dcapiResponseData => {
          dcapiResponse = "resolved";
          if (isFunction(dcapiReslove)) {
            dcapiReslove(dcapiResponseData);
          }
        })
        .catch(error => {
          /* Dcapi will reject in rare cases where something is wrong with the file
              if both faile then show a dialog here
          */
          dcapiResponse = "rejected";
          if (isFunction(dcapiReject)) {
            dcapiReject(error, ajsResponse, dcapiResponse);
          }
        });
    }
  } else {
    response.then(ajsResolve).catch(ajsReject);
  }
};
export { docAPIResponseHandler };
